function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function HandleSuccess( e )
{
    var type            = e.currentTarget.dataset.type;
    window.location.href = window.location.origin + "/pages/thank-you?type=" + encodeURIComponent( type );
}

function SendToKlaviyo( param, e, cb )
{
    function TryNow( e )
    {      
        if ( window._learnq )
        {
            // console.log( "Sending to klaviyo with params:" + JSON.stringify( param ) );
            window._learnq.push( param );
            cb();

        }
        else
        {
            setTimeout( TryNow, 500 );
        }
    }
    TryNow( e );
}

function HandleConsultationClick()
{
    var popup = document.querySelector( ".bridgman-consultation-popup" );
    popup.setAttribute( "style", "display: block" );
  	popup.classList.remove( "hidden" );
}

function showRequestCatalogueForm( element )
{
    var catalogueForm = document.querySelector( ".commercial-popup" );

    if( catalogueForm.style.display = "none" )
    {
        catalogueForm.style.display = "block";
    }
}

function handleFormNavigation( element )
{
    // $('.book_actionbar .next,.bridgman_comm_catalogue_steps span:nth-child(1)').click(function (e) {
    //     console.log('I AM CLICKED');
    //     var catalogue_name = $('.book_image_outer.active').data('catalogue-name');
    //     if(catalogue_name == undefined){
    //       if($('.bookError').length == 0)
    //       {
    //         $('<p class="bookError" style="margin-top:10px;text-align:left;font-size: 18px;color:#c14848;font-weight: 500;">Select at least one Catalogue.</p>').insertBefore('.book_wrapper');
    //       }
    //     }else{
    //       $('.bridgman_catalogue_panel').addClass('hidden');;
    //       $('.panel_methods').removeClass('hidden');;
    //     }
    //     return false;
    //   });
    //   $('.methods_wrapper .next,.bridgman_comm_catalogue_steps span:last-child').click(function (e) {
    //     console.log('I AM CLICKED too');
    //     var method = $('.action_button.active').data('method');
    //     if(method == undefined){
    //       if($('.methodError').length == 0)
    //       {
    //         $('<p class="methodError" style="margin-top:10px;text-align:left;font-size: 18px;color:#c14848;font-weight: 500;">Select at least one method.</p>').insertAfter('.panel_methods .panel_heading');
    //       }
    //     }else{
    //       $('.bridgman_catalogue_panel').addClass('hidden');
    //       $('.panel_methods').addClass('hidden');
    //     }
    //     return false;
    //   });

    var parent = document.querySelector( ".commercial-popup-inner" );
    var method = $('.action_button.active').data('method');
    var count = 0;

    var methodsContainer = document.querySelector( ".panel_methods" )
    // methodsContainer.classList.toggle( "hidden" );
    if ( method )
    {

        if( methodsContainer.classList.contains( "hidden") )
        {
            methodsContainer.classList.remove( "hidden" );
        }
        else
        {
            methodsContainer.classList.add( "hidden" );
        }
    
        var forms = document.querySelectorAll( ".bridgman_catalogue_panel" );
        for( var i = 0; i < forms.length; i++ )
        {
            var form = forms[ i ];
            var formName = form.dataset.name;
            form.classList.add( "hidden" );
            if( formName == method )
            {
                form.classList.remove( "hidden" );
            }
        }
    }
    else
    {
        if( count > 0)
        {
            $('<p class="methodError" style="margin-top:10px;text-align:left;font-size: 18px;color:#c14848;font-weight: 500;">Select at least one method.</p>').insertAfter('.panel_methods .panel_heading');
            count++;
        }
    }
    
}

function setTelInputFilter(textbox, inputFilter) 
{
    // Convert HTML Collection to an array:
    var inputArray = Array.prototype.slice.call(textbox)
    var eventArray = ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"];

    for( var i = 0; i < eventArray.length; i++ )
    {
        var event = eventArray [ i ]
        for( var j = 0; j < inputArray.length; j++ )
        {
            var input = inputArray[ j ];
            input.addEventListener(event, function() {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = "";
            }
            });
        }
    }
}

function onSearchBlur() 
{
    var mannualAddress = document.querySelector('#manual-address');
    mannualAddress.checked = false; 
}
  
window.addEventListener( "DOMContentLoaded", function( e )
{
    $( 'a[ href="#consultation" ]' ).on( "click",  function()
    {
        HandleConsultationClick( );
    } );
    $( 'a[ href="#catalogue" ]' ).on( "click",  function()
    {
        showRequestCatalogueForm( e.currentTarget )
    } );

    setTelInputFilter(document.querySelectorAll(".number-input"), function(value) 
    {
        return /^\d*\.?\d*$/.test(value); // Allow digits and '.' only, using a RegExp
    });
} );

$( document ).ready(function () 
{
    document.getElementById('catalogue_Where_did_you_hear_about_us').addEventListener('change', function() {
        //console.log('You selected: ', this.value);
        var input_other = document.getElementById('catalogue_Where_did_you_hear_about_us_other')
        if(this.value == 'Other'){
            input_other.classList.remove('hide');
        } else {
            input_other.classList.add('hide');
        }
    });

    $("#commercial-page-form-email").submit(function (e) 
    { 
        e.preventDefault();
        e.stopImmediatePropagation();    // This is to prevent the .submit firing twice
        
        hj("event","commercial_catalogue_request");
        var pannel = SearchParentsFor( e.currentTarget, "bridgman_catalogue_panel" );
        
        var selectedCatalogues = document.querySelectorAll( ".bridgman-commercial-catalogue-list-container .single_book .active" );
        
        function HandleOneCatalogue( idx )
        {
            if( idx < selectedCatalogues.length )
            {
                document.querySelector( ".catalogue-error-text" ).classList.add( "hidden" );
                var selectedCatalogue   = selectedCatalogues[ idx ];
                var form                = e.currentTarget;
                var _learnq             = _learnq || [];
                if( form.querySelector( "input[ name='data-capture' ]" ) )
                {
                    var accepts_marketing   = form.querySelector( "input[ name='data-capture' ]" ).checked;
                }
                var Where_did_you_hear_about_us = form.querySelector( '[name="catalogue_Where_did_you_hear_about_us"]' ).value;
                if(Where_did_you_hear_about_us == 'Other'){
                    Where_did_you_hear_about_us = form.querySelector( '[name="catalogue_Where_did_you_hear_about_us_other"]' ).value;
                }
                var catalogue = {
                    Response_Type: 'Email',
                    Catalogue_Type: selectedCatalogue.getAttribute( "data-catalogue-type" ),
                    Catalogue_Name: selectedCatalogue.getAttribute( "data-catalogue-name" ),
                    $source: Where_did_you_hear_about_us
                };

                if( accepts_marketing && accepts_marketing == true )
                {
                    catalogue.$accepts_marketing = accepts_marketing;
                }

                var email;
                var elements = form.querySelectorAll( "input" );
                for ( var i = 0; i < elements.length; i++ )
                {
                    var element = elements[ i ];
                    catalogue[ element.getAttribute( "name" ) ] = element.value;

                    if( element.type == "email" )
                    {
                        email = element.value;
                        catalogue.$email = email;
                    }
                }

                var selectElements = form.querySelectorAll( "select" );
                for ( var i = 0; i < selectElements.length; i++ )
                {
                    var selectElement = selectElements[ i ];
                    if( selectElement.getAttribute( "name" ) != "catalogue_Where_did_you_hear_about_us" )
                    {
                        catalogue[ selectElement.getAttribute( "name" ) ] = selectElement.value;
                    }
                }

                if( catalogue.$accepts_marketing )
                {
                    var properties  =  { "$email" : email, "Catalogue_Type" : catalogue.Catalogue_Type, "Catalogue_Name" : catalogue.Catalogue_Name, "$source": catalogue.$source, "Response_Type" : "Email", "$accepts_marketing": catalogue.$accepts_marketing };
                }
                else
                {
                    var properties  =  { "$email" : email, "Catalogue_Type" : catalogue.Catalogue_Type, "Catalogue_Name" : catalogue.Catalogue_Name, "$source": catalogue.$source, "Response_Type" : "Email" };
                }
                var trackProperties  = { "event" : "Request Catalogue", "trackData" : catalogue };
                KlaviyoTrackV2( properties, trackProperties, function()
                {
                    jQuery.post( "https://hooks.zapier.com/hooks/catch/9220888/o0xxmfx/silent/", catalogue ).then( function()
                    {
                        HandleOneCatalogue( idx + 1 );
                    } );
                });

            }
            else
            {
                HandleSuccess( e )
            }
        }

        if( selectedCatalogues && selectedCatalogues.length )
        {
            HandleOneCatalogue( 0 );     
        }
        else
        {
            
            // var catalogues = pannel.querySelectorAll( ".bridgman-commercial-catalogue-list-container .single_book .book_image_outer" );
            // for( var i = 0; i < catalogues.length; i++ )
            // {
            //     var catalogue = catalogues[ i ];
            //     catalogue.click();
            // }
            // selectedCatalogues = pannel.querySelectorAll( ".bridgman-commercial-catalogue-list-container .single_book .active" );
            // HandleOneCatalogue( 0 );
            var parent = e.currentTarget.parentNode.parentNode;
            console.log(parent)

            parent.querySelector( ".catalogue-error-text" ).classList.remove( "hidden" );
        }

    });

    $("#commercial-page-form").submit(function (e) 
    { 
        e.preventDefault();
        e.stopImmediatePropagation();    // This is to prevent the .submit firing twice

        hj("event","commercial_catalogue_request");
        // var pannel              = SearchParentsFor( e.currentTarget, "bridgman_catalogue_panel" );
        var selectedCatalogues  = document.querySelectorAll( ".bridgman-commercial-catalogue-list-container .single_book .active" );
        function HandleOneCatalogue( idx )
        {
            if( idx < selectedCatalogues.length )
            {
                document.querySelector( ".catalogue-error-text" ).classList.add( "hidden" );
                var selectedCatalogue   = selectedCatalogues[ idx ];
                var form                = e.currentTarget;
                var _learnq             = _learnq || [];

                var accepts_marketing   = form.querySelector( "input[ name='data-capture' ]" ).checked;
                var Where_did_you_hear_about_us = form.querySelector( '[name="catalogue_Where_did_you_hear_about_us"]' ).value;
                if(Where_did_you_hear_about_us == 'Other'){
                    Where_did_you_hear_about_us = form.querySelector( '[name="catalogue_Where_did_you_hear_about_us_other"]' ).value;
                }
                var catalogue = {
                    Response_Type: 'POST',
                    Catalogue_Type: selectedCatalogue.getAttribute( "data-catalogue-type" ),
                    Catalogue_Name: selectedCatalogue.getAttribute( "data-catalogue-name" ),
                    $source:Where_did_you_hear_about_us
                };

                if( accepts_marketing && accepts_marketing == true )
                {
                    catalogue.$accepts_marketing = accepts_marketing;
                }

                var email;
                var elements = form.querySelectorAll( "input" );
                for ( var i = 0; i < elements.length; i++ )
                {
                    var element = elements[ i ];
                    catalogue[ element.getAttribute( "name" ) ] = element.value;

                    if( element.type == "email" )
                    {
                        email = element.value;
                        catalogue.$email = email;
                    }
                }

                var selectElements = form.querySelectorAll( "select" );
                for ( var i = 0; i < selectElements.length; i++ )
                {
                    var selectElement = selectElements[ i ];
                    if( selectElement.getAttribute( "name" ) != "catalogue_Where_did_you_hear_about_us" )
                    {
                        catalogue[ selectElement.getAttribute( "name" ) ] = selectElement.value;
                    }
                }

                if( catalogue.$accepts_marketing )
                {
                    var properties  =  { "$email" : email, "Catalogue_Type" : catalogue.Catalogue_Type, "Catalogue_Name" : catalogue.Catalogue_Name, "$source": catalogue.$source, "Response_Type" : "POST", "$accepts_marketing": catalogue.$accepts_marketing };
                }
                else
                {
                    var properties  =  { "$email" : email, "Catalogue_Type" : catalogue.Catalogue_Type, "Catalogue_Name" : catalogue.Catalogue_Name, "$source": catalogue.$source, "Response_Type" : "POST" };
                }
                var trackProperties  = { "event" : "Request Catalogue", "trackData" : catalogue };
                KlaviyoTrackV2( properties, trackProperties, function()
                {
                    jQuery.post( "https://hooks.zapier.com/hooks/catch/9220888/o0xxmfx/silent/", catalogue ).then( function()
                    {
                        HandleOneCatalogue( idx + 1 );
                    } );
                });

            }
            else
            {
                HandleSuccess( e );
            }
        }

        if( selectedCatalogues && selectedCatalogues.length )
        {
            HandleOneCatalogue( 0 );     
        }
        else
        {
            var parent = e.currentTarget.parentNode;
            parent.querySelector( ".catalogue-error-text" ).classList.remove( "hidden" );
        }

    });
    
    $("#consultation-page-form").submit( function( e ) 
    { 
        e.preventDefault();
        e.stopImmediatePropagation();

        var form                    = e.currentTarget;
        var _learnq                 = _learnq || [];

        var full_name = form.querySelector( "#consulatation_Fullname" ).value;
        var phone_number = form.querySelector( "#catalogue_Phone" ).value;
        var email = form.querySelector( "#catalogue_email" ).value;
        var company_name = form.querySelector( "#commercial-popup_Company_Name" ).value;
        var company_website = form.querySelector( "#company_website" ).value;
        var accepts_marketing = form.querySelector( "input[ name='data-capture' ]" ).checked;
        var company_sector = form.querySelector( "#catalogue_sector" ).value;
        var Where_did_you_hear_about_us = form.querySelector( '[name="catalogue_Where_did_you_hear_about_us"]' ).value;

        if(Where_did_you_hear_about_us == 'Other'){
            Where_did_you_hear_about_us = form.querySelector( '[name="catalogue_Where_did_you_hear_about_us_other"]' ).value;
        }

        var consultationCustomer = 
        {
            Catalogue_Type: '',
            $full_name: full_name,
            $phone_number: phone_number,
            $email: email,
            $company_name: company_name,
            $company_website: company_website,
            $company_sector: company_sector,
            $source: Where_did_you_hear_about_us
        };

        if( accepts_marketing && accepts_marketing == true )
        {
            consultationCustomer.$accepts_marketing = accepts_marketing;
        }

        if( consultationCustomer.$accepts_marketing )
        {
            var properties  =  { "$email" : email, "Catalogue_Type" : '', "$source": consultationCustomer.$source, "Response_Type" : "POST", "$accepts_marketing": consultationCustomer.$accepts_marketing };
        }
        else
        {
            var properties  =  { "$email" : email, "Catalogue_Type" : '', "$source": consultationCustomer.$source, "Response_Type" : "POST" };
        }
        var trackProperties  = { "event" : "Request Consultation", "trackData" : consultationCustomer };
        KlaviyoTrackV2( properties, trackProperties, function()
        {
            jQuery.post( "https://hook.eu2.make.com/5juj73ocd7jmwifogma3v31b2tve1cjf", consultationCustomer ).then( function()
            {
                HandleSuccess( e );
            } );
        });
    });

});

window.addEventListener( "DOMContentLoaded", function()
{
    $( '.consultation-popup-close' ).on( "click", function()
    {
        document.querySelector( ".bridgman-consultation-popup" ).removeAttribute( "style" );
        document.querySelector( ".consultation-success" ).classList.add( "hidden" );
    } );
} );